/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * 广告位通用组件
 */
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import isPrerendering from '@/shared/utils/isPrerendering';
import { defaultGeoInfo } from '@/constant/system';
import platform from '@/shared/utils/platform';
import store from '@/store';
import { changeTabbarMaskStatus } from '@/api/native/container';
import isShowContainerPath from '@/shared/utils/isShowContainerPath';
import { advLinkJump } from '@/shared/utils/advLinkJump';
import { getTabIdByPath } from '@/shared/utils/getTabIdByPath/getTabIdByPath';
import { financeWeiXinMpUrlScheme } from '@/constant';
import wechat from '@/api/native/wechat';
import { agreementService } from '@/service/confirm-agreements';
import { AdvEvent, AdvEventTypes } from '../types';
import { appEnv } from '../index';
import style from './index.module.scss';
import { h5ComponentsType } from './types';

// 注册AdvMaster, 初始化tianqi之后再use
const { UBT } = (window as any).TianQi;

const h5ComponentsPromise = import(
  /* webpackChunkName: "h5-components" */'@hb/h5-components'
).then((res) => {
  const { AdvMaster } = res.default as h5ComponentsType;
  Vue.use(AdvMaster, {
    UBT,
  });
  return res.default;
});

@Component
export default class AdvCommonContainer extends Vue {
  /**
   * 广告位 uuid
   */
  @Prop(String)
  private advMasterId!: string;

  /**
   * 是否自己处理点击事件
   */
  @Prop({
    type: Boolean,
    default: true,
  })
  private customClick!: boolean;

  /**
   * 是否自己处理点击confirm事件
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  private customClickConfirm!: boolean;

  /**
   * 是否同意授权服务协议
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  private needConfirmFinanceAgreements!: boolean;

  /**
   * 是否传入自定义样式
  */
  @Prop(String) readonly customClassName!: string;

  /**
   * 是否使用自定义的定位信息，传true,默认全国，以解决无需弹起授权弹窗
   */
  @Prop({
    type: Boolean,
    default: platform.isWechatMini,
  })
  private useDefaultGeo?: boolean;

  /**
   * 是否增加额外参数
   */
  @Prop({
    type: Object,
    default: {},
  })
  private advExtendInfo?: Record<string, unknown>;

  /**
   * 组件计算自行渲染的逻辑处理
   */
  @Prop({
    type: () => Boolean,
  })
  private shouldSelfRender?: (data: Dictionary)=> boolean;

  /**
   * 是否处理  显示、点击、关闭事件
   * 场景：首页 广告位弹窗，在容器内，
   * 广告位展示时，隐藏tabbar，
   * 广告位隐藏时\点击跳转时，显示tabbar
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  private customVisibility!: boolean;


  // 是否阻止当前弹窗关闭
  private stopClose = false;

  private confirm() {
    this.$emit('confirm');
  }

  private cancel() {
    this.$emit('cancel');
  }

  private load() {
    this.$emit('load', this.bannerProp.cache);
  }

  private bannerProp = {
    id: this.advMasterId, // 用id，让组件自己调接口渲染
    cache: null, // 通过接口拿数据复制渲染
    customClick: this.customClick, // 是否自己处理点击事件
  }

  /** 当前广告位的额外信息传入 */
  private get advExtendInfos() {
    // 存在额外字段的时候才传入
    if (this.advExtendInfo && Object.keys(this.advExtendInfo).length) {
      return {
        extendInfos: {
          [this.advMasterId]: {
            customerParams: this.advExtendInfo,
          },
        },
      };
    }
    return {};
  }

  private async getCache() {
    const advEvt = this.useDefaultGeo ? { geo: defaultGeoInfo } : { ...this.advExtendInfos };
    const { advMasterApi } = await h5ComponentsPromise;
    advMasterApi.getBannerInfos([this.advMasterId], appEnv, {
      // systemCode: '61', // 供调试使用 iOS:61；安卓：62；支付宝环境：65；微信环境：64；其他：63
      ...advEvt,
    }).then((adxData) => {
      if (adxData.adm && adxData.adm.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        adxData.adm.forEach((imp: any) => {
          /** creative 非空数组 才命中任务 */
          if (imp.impid === this.advMasterId && imp.creative && imp.creative.length > 0) {
            // 根据返回数据动态计算是否需要自己处理弹窗样式的情况
            // 1.存在动态计算的方法
            // 2.动态计算的方法返回true
            // 3.将数据加载完毕事件 & 数据 回传给调用方
            if (this.shouldSelfRender && this.shouldSelfRender(imp)) {
              this.$emit('dataLoad', imp);
              return;
            }
            this.bannerProp.cache = imp;
          } else {
            this.$emit('noDataLoad');
          }
        });
      } else {
        this.$emit('noDataLoad');
      }
    }).catch(() => {
      this.$emit('noDataLoad');
    });
  }

  // 数科独立 app 内，获取广告位
  private async getSkAppCache() {
    const advEvt = this.useDefaultGeo ? { geo: defaultGeoInfo } : { ...this.advExtendInfos };
    const { advMasterApi } = await h5ComponentsPromise;
    advMasterApi.getBannerInfos([this.advMasterId], appEnv, {
      systemCode: platform.isIOS ? '61' : '62', // 供调试使用 iOS:61；安卓：62；支付宝环境：65；微信环境：64；其他：63
      token: store.state.base.originUserInfo.token,
      ...advEvt,
    }).then((adxData) => {
      if (adxData.adm && adxData.adm.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        adxData.adm.forEach((imp: any) => {
          /** creative 非空数组 才命中任务 */
          if (imp.impid === this.advMasterId && imp.creative && imp.creative.length > 0) {
            this.bannerProp.cache = imp;
          }
        });
      }
    });
  }

  private mounted() {
    if (!isPrerendering()) {
      // 通过接口调用配置数据
      // 独立app 内，且提现申请审核中页面 广告位id，去请求特殊的广告位数据
      if (platform.isSkApp && this.advMasterId === '071c057cdb334ca399de7161977ea25c') {
        this.getSkAppCache();
      } else {
        this.getCache();
      }
    }
  }

  private clickType = '' as AdvEventTypes;

  // watch 监听组件的点击类型 以解决close事件先于 click 事件触发 导致的问题
  @Watch('clickType')
  private clickTypeChange(val: string) {
    /** 关闭弹窗 */
    if (val === AdvEventTypes.ONCLOSE) {
      this.cancel();
      // hack广告平台没有提供点击时不关闭弹窗方法，只能再关闭后，再设置一次值
      // TODO:推动广告平台提供方案
      if (this.stopClose) {
        this.bannerProp.cache = null;
        this.getCache();
        this.stopClose = false;
      }

      if (this.customVisibility) {
        /** 隐藏tabbar遮罩 */
        changeTabbarMaskStatus({
          show: false,
          duration: 50,
          tabId: getTabIdByPath(),
        });
      }
    }
    /** 组件显示 */
    if (val === AdvEventTypes.ONLOAD) {
      this.load();
      if (this.customVisibility) {
        /** 在首页 我的页面 才显示遮罩 */
        if (isShowContainerPath(this.$route.path)) {
          changeTabbarMaskStatus({
            show: true,
            duration: 100,
            opacity: 0.6,
            tabId: getTabIdByPath(),
          });
        }
      }
    }

    if (val === AdvEventTypes.ONCLICK) {
      /** 关闭弹窗场景 */
      if (this.customVisibility) {
        /** 在首页 我的页面 才需操作遮罩逻辑 */
        if (isShowContainerPath(this.$route.path)) {
          changeTabbarMaskStatus({
            show: false,
            duration: 100,
            opacity: 0.6,
            tabId: getTabIdByPath(),
          });
        }
      }
    }
  }

  private handleConfirm(event: AdvEvent) {
    if (this.customClickConfirm) {
      this.confirm();
    } else {
      const { link, ext } = event.data.dataset.item || {};
      if (link) {
        // 临时方案，阻止跳转权益详情页时关闭弹窗（定制化场景，保留在组件层处理）
        if (link.includes('AppFinanceLoanH5') && link.includes('right-detail')) {
          this.stopClose = true;
        }

        // 使用公共广告位跳转方法
        advLinkJump(link);
      } else if (ext?.jumpConfig) {
        /**
         * 若是配置是‘微信小程序’模式 jumpConfig对象有小程序的appid、path
         * userName: 小程序的appid
         * path: 小程序页面page?参数，如：/pages/index/index?id%3D123&name%3Dhello
         */
        const { userName, path } = ext?.jumpConfig || {};

        if (userName && path) {
          const [page, query] = String(path).split('?');

          window.location.href = `${financeWeiXinMpUrlScheme.replace(wechat.appId, userName)}&path=${page}&query=${query}`;
        }
      }
    }
  }

  /** 监听广告事件 */
  private async handleAdvEvent(event: AdvEvent) {
    /** 关闭弹窗事件，且 是dsl 领取关闭弹窗场景，不给关闭事件赋值 */
    if (!(event.type === AdvEventTypes.ONCLOSE && event?.data?.['dsl-shttp-config']?.['success-action'] === 'close')) {
      /** 非关闭弹窗事件，赋值点击类型 */
      this.clickType = event.type;
    }

    /** 点击 */
    if (event.type === AdvEventTypes.ONCLICK) {
      if (this.needConfirmFinanceAgreements) {
        const confirmResult = await agreementService.confirmFinanceAgreements();
        if (confirmResult) {
          this.handleConfirm(event);
        }
      } else {
        this.handleConfirm(event);
      }
      this.$emit('clickEmitter', event);
    }
  }

  private render() {
    if (this.bannerProp.cache) {
      return (
        <div class={[
          style.advContainer,
          this.customClassName,
        ]}>
          {this.bannerProp.cache && this.renderComp()}
        </div>
      );
    }
    return null;
  }

  private renderComp() {
    return (
      <adv-master
        bannerProp={this.bannerProp}
        onOnEvent={this.handleAdvEvent.bind(this)}
        env={appEnv}
      />
    );
  }
}
// 广告平台系统本地调试：https://hellobike.yuque.com/gzxsb9/iank77/rzlzzh
